import moment from "moment-timezone";
import { SERVICE_ADMIN_MENTAL_HEALTH, SERVICE_TYPE } from "helper/constant";

/* datetime when the note was closed/signed, with fallbacks for created/updated. */
export const getNoteCloseTimestamp = note => {
  if (!note) return null;

  const timestamps = [
    note.signed_date,
    note.updated_at,
    note.created_at
  ].filter(Boolean);
  if (!timestamps.length) return null;

  return timestamps
    .map(value => moment.tz(value, moment.tz.guess()))
    .reduce((latest, current) => (current.isAfter(latest) ? current : latest));
};

export const isCloseTimestampToday = note => {
  const closeTimestamp = getNoteCloseTimestamp(note);
  if (!closeTimestamp) return false;

  const today = moment()
    .utc()
    .local()
    .format("YYYY-MM-DD");
  return closeTimestamp.format("YYYY-MM-DD") === today;
};

export const isMentalHealthServiceAdmin = auth =>
  Number(auth?.admin_role_id) === SERVICE_ADMIN_MENTAL_HEALTH;

export const isMentalHealthVisit = visit =>
  visit?.service_id === SERVICE_TYPE.MENTAL_HEALTH;

export const visitHasBilling = visit =>
  Boolean(visit?.is_billing_complete || visit?.visit_bill);

export const canReopenMentalHealthSignedNote = (auth, visit, note) => {
  if (!isMentalHealthServiceAdmin(auth)) return false;
  if (!isMentalHealthVisit(visit)) return false;
  if (!visitHasBilling(visit)) return false;
  if (!note?.signed_date) return false;

  return isCloseTimestampToday(note);
};
